import * as React from 'react';
import { match } from 'react-router';
import Summary from './Summary/Summary';
import Intro from './Intro/Intro';
import PlanHolderList from './PlanHolders/List';
import NewPlanHolder from './PlanHolders/PlanHolder';
import BeneficiariesList from './Beneficiaries/List';
import NewBeneficiary from './Beneficiaries/Beneficiary';
import Declarations from './Declarations/Declarations';
import { PlanHolder as PlanHolderModel, Beneficiary as BeneficiaryModel, ApplicationFormState} from '../../models/applicationForm';

interface ApplicationFormProps extends ApplicationFormState {
  match: match<{section: string }>;
  setPlanholder: (planholder: PlanHolderModel) => object;
  setBeneficiary: (beneficiary: BeneficiaryModel) => object;
}

enum Section {
  Summary = 'summary',
  Intro = 'intro',
  Planholders = 'planholders',
  NewPlanholder = 'new-planholder',
  Beneficiaries = 'beneficiaries',
  NewBeneficiary = 'new-beneficiary',
  Declarations = 'declarations'
}

const ApplicationForm = (props: ApplicationFormProps) => {
  const section: string = props.match.params.section;

  return (
    <div>
      {
        section === Section.Summary && <Summary />
      }
      {
        section === Section.Intro && <Intro />
      }
      {
        section === Section.Planholders && <PlanHolderList />
      }
      {
        section === Section.NewPlanholder && <NewPlanHolder planholder={props.planholder} setPlanholder={props.setPlanholder} />
      }
      {
        section === Section.Beneficiaries && <BeneficiariesList />
      }
      {
        section === Section.NewBeneficiary && <NewBeneficiary beneficiary={props.beneficiary} setBeneficiary={props.setBeneficiary} />
      }
      {
        section === Section.Declarations && <Declarations />
      }
    </div>
  )
}

export default ApplicationForm;
